import { CONFIG } from "../../appConfig";
import STATE from "../../constants/state";

const SUBSCRIPTION = "subscription/";

export default {
  /**
   * @desc submit user information to sign up to email extras
   * @param {Object} data {params, payload}
   * @returns {Object}
   * @memberof services.gma.subscriptions
   * @example
   * const data = {payload: { first_name, last_name, email, zip_code, country_of_residence }};
   * services.gma.subscriptions.optInExtras(data);
   */
  optInExtras(data) {
    const { payload = {}, params = {} } = data;
    return {
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${SUBSCRIPTION}optInExtras`,
      data: payload,
      params,
    };
  },

  /**
   * @desc submit subscription retrieved data to unsubscribe email extras
   * @param {Object} data {params, payload}
   * @returns {Object}
   * @memberof services.gma.subscriptions
   * @example
   * const data = {payload: { first_name, last_name, email, country_of_residence, email_source_code, language, opt_in: false}};
   * services.gma.subscriptions.optOutExtras(data);
   */
  optOutExtras(data) {
    const { payload = {}, params = {} } = data;
    return {
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${SUBSCRIPTION}optOutExtras`,
      data: payload,
      params,
    };
  },

  /**
   * @desc submit user information or subscription id to fetch subscription details
   * @param {Object} data {params}
   * @returns {Object}
   * @memberof services.gma.subscriptions
   * @example
   * const data = {payload: { first_name, last_name, email, loyalty_code, id }};
   * services.gma.subscriptions.optInExtras(data);
   * // dispatched results stored in `state.gmi.gma.subscription.details`
   */
  retrieve(data) {
    const { params = {} } = data;
    return {
      method: "GET",
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${SUBSCRIPTION}retrieve`,
      params,
      statePath: STATE.GMA.SUBSCRIPTION.DETAILS,
    };
  },

  /**
   * @desc submit user information to sign up to email extras
   * @param {Object} data {params, payload}
   * @returns {Object}
   * @memberof services.gma.subscriptions
   * @example
   * const data = {first_name, last_name, email, zip_code, country_of_residence, source_code };
   * services.gma.subscriptions.createIndividual(data);
   */
  createIndividual(data) {
    return {
      method: "POST",
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${SUBSCRIPTION}createIndividual`,
      data,
    };
  },
};
